import { Component, OnInit } from '@angular/core';
import { UtilService, VariablesService, VwoService } from '../../../shared/services';

@Component({
  selector: 'app-social-number',
  templateUrl: './social-number.component.html',
  styleUrls: ['./social-number.component.scss']
})
export class SocialNumberComponent implements OnInit {

  userData;
  isSipSubscribed;

  constructor(
    public variablesService: VariablesService,
    public util: UtilService,
    public vwo: VwoService
  ) { }
  currentYear = new Date().getFullYear();

  ngOnInit() {
    this.variablesService.userData.subscribe({
      next: (res) => {
        this.userData = res;
        if (res) {
          this.checkSipType();
        }
      }
    });
  }

  checkSipType() {
    const sip_status_flag = this.util.checkForActiveSip(this.userData?.listsubscriptions);
    if (sip_status_flag.toString().match('1|2')) {
      this.isSipSubscribed = true;
    }
  }

  whatsappChat() {
    this.util.nativeNavigation('https://api.whatsapp.com/send?phone=91' + this.variablesService.contactUsMobNumber, true);
  }
}
